import { Directive, HostListener, Self, Input, OnDestroy, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { NgSelectComponent } from '@ng-select/ng-select';
@Directive({
  exportAs: 'cpSelect',
  selector: '[cpSelect]',
})
export class CpSelect implements OnDestroy {
  readonly stateChanges: Subject<void> = new Subject<void>();
  // todo:  placeholder doesnt seem to do anything need further research to remove
  @Input() placeholder: string;
  focus = false;

  constructor(@Self() private ngControl: NgControl, private renderer: Renderer2, private host: NgSelectComponent) {}

  get control() {
    return this.ngControl;
  }

  @HostListener('focus')
  onFocus() {
    this.focus = true;
    // adds the box focus styles if it has cp-box__select class
    if (this.host && this.host.classes === 'cp-box__select') {
      this.host.focused = true;
      this.renderer.addClass(this.host.element, 'cp-box__select--focus');
    }

    this.stateChanges.next();
  }
  @HostListener('focusout')
  onFocusout() {
    this.focus = false;
    // removes the box focus styles if it has cp-box__select class and its unfocused
    if (this.host && this.host.classes === 'cp-box__select') {
      this.host.focused = false;
      this.renderer.removeClass(this.host.element, 'cp-box__select--focus');
    }

    this.stateChanges.next();
  }

  ngOnDestroy() {
    this.stateChanges.complete();
  }
}
